<!-- 
File upload input.
-->
<template>
  <div class="our-file">
    {{ title }}
    <input
      ref="fileInput" 
      :accept="accept"
      type="file"
      @change="fileSelected"
    >
  </div>
</template>

<script>
export default {
  name: "UploadButton",
  props: {
    title: {
      type: String,
      default: "Upload"
    },
    accept: {
      type: String,
      default: ""
    }
  },
  methods: {
    fileSelected(e) {
      if (e.target.files[0]) {
        this.$emit("input", e.target.files[0]);
        this.$refs.fileInput.value = "";
      }
    }
  }
};
</script>

<style scoped>
.our-file {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.our-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>
